export default "__VITE_ASSET__abd2815b__"